export default {
    message: "Die unten aufgeführten Artikel sind nicht auf Lager und wurden aus Ihrem Warenkorb entfernt. Bitte treffen Sie eine andere Auswahl.",
    buttons: {
        ok: "OK"
    }
}